import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customers/$customerId',
}).lazy(() => import('./$customerId.index.lazy').then((d) => d.Route))
